import * as React from 'react'

import { Box, Button, useToggle } from '@factorialco/deprecated-design-system'
import 'generated/resources/graphql'
import {
  PerformancePeerAssignmentsReviewEvaluationFragment,
  PerformancePeerAssignmentsTargetFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import AddPeerModal from 'modules/performance_process/components/peerAssignments/AddPeerModal'
import RemovePeersModal from 'modules/performance_process/components/peerAssignments/RemovePeers/RemovePeersModal'

export const Actions: React.FC<{
  processTarget: PerformancePeerAssignmentsTargetFragment
  currentPeerEvaluations: PerformancePeerAssignmentsReviewEvaluationFragment[]
}> = ({ processTarget, currentPeerEvaluations }) => {
  const [showAddPeerModal, toggleShowAddPeerModal] = useToggle()
  const processTargetAccessId = Number(processTarget.id)
  const [showRemovePeersModal, toggleRemovePeersModelModal] = useToggle()
  const currentPeerEmployeeIds = currentPeerEvaluations.flatMap(
    (evaluation) => evaluation.reviewerEmployeeName?.id || []
  )

  const canRemovePeers = currentPeerEmployeeIds.length > 0
  const processTargetEmployeeId = processTarget.employeeName?.id
  return (
    <Box flexDirection="row" gap="s8" justifyContent="flexEnd">
      {showAddPeerModal && processTargetEmployeeId && (
        <AddPeerModal
          key={processTarget.id}
          processTargetAccess={processTarget}
          processTargetEmployeeId={processTargetEmployeeId}
          currentPeerEmployeeIds={currentPeerEmployeeIds}
          onClose={toggleShowAddPeerModal(false)}
        />
      )}
      {showRemovePeersModal && (
        <RemovePeersModal
          key={processTarget.id}
          processTargetId={processTargetAccessId}
          processTargetAccess={processTarget}
          currentPeerEmployeeIds={currentPeerEmployeeIds}
          currentPeerEvaluations={currentPeerEvaluations}
          onClose={toggleRemovePeersModelModal(false)}
        />
      )}
      {canRemovePeers && (
        <Button
          type="secondary"
          aria-label={i18n.t('performance_process.reviews.evaluations.remove_peers')}
          onClick={toggleRemovePeersModelModal(true)}
          iconName="delete"
        />
      )}

      <Button
        type="secondary"
        aria-label={i18n.t('performance_process.reviews.peer_management.assign_peers')}
        onClick={toggleShowAddPeerModal(true)}
        iconName="add"
      />
    </Box>
  )
}
